import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MandatePermissions } from '../../models/enum/mandate-permissions.enum';
import { MandateService } from '../../services/mandate/mandate.service';

export const deliveredMedicationsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const mandateService = inject(MandateService);

  return mandateService.hasAccess(MandatePermissions.consultDeliveredMedications) ? true : router.parseUrl('/homepage');
};
